import { createSlice } from '@reduxjs/toolkit'
import { PURGE } from "redux-persist";

const initialState = {
    secretKey:null,
    accessKey:null,
    access_token:null
}

export const userApiSlice = createSlice({
    name: 'userApiSlice',
    initialState,
    reducers: {
        setUserSecretKey:(state,action)=>{
            state.secretKey=action.payload
        },
        setUserAccessKey:(state,action)=>{
            state.accessKey=action.payload
        },
        setToken:(state,action)=>{
            state.access_token=action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(PURGE, () => initialState); // THIS LINE
    }
})

export const { setUserSecretKey,setUserAccessKey,setToken} = userApiSlice.actions
export default userApiSlice.reducer